import { ENUM__page_generation_layout } from '@/pages/page_generation/_enums/ENUM__page_generation_layout';
import { ENUM__page_generation_layout_images_edit_tab } from '@/pages/page_generation/layouts/assets_images/ENUM__page_generation_layout_images_edit_tab';
import { PayloadAction } from '@reduxjs/toolkit';
import { assert_instanceof } from '@shared/asserts/utils_asserts';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { STATE__ui } from '../STATE__ui';

interface PAYLOAD {
  field: FIELD__base;
  key: keyof STATE__ui;
}

export const LOCAL__ui_set_field_for_generation_layout = (payload: PAYLOAD): PayloadAction<PAYLOAD> => ({
  type: ENUM__redux_action.UI__IMAGE__SET_FIELD_FOR_GENERATION_LAYOUT,
  payload,
});

export const INIT_LOCAL__ui_set_field_for_generation_layout = (state: STATE__ui, action: PayloadAction<PAYLOAD>) => {
  let value_previous = state[action.payload.key];
  assert_instanceof(value_previous, FIELD__base);

  (state as any)[action.payload.key] = action.payload.field.clone();

  try_reset_generation_image_edit_tab(state);
};

//todo: move to watcher
function try_reset_generation_image_edit_tab(state: STATE__ui) {
  if (state.g_general__layout != ENUM__page_generation_layout.ASSETS) return; //no need to reset
  if (!state.g_image_edit__field.is_stub()) return; //no need to reset

  state.g_image_edit__tab = ENUM__page_generation_layout_images_edit_tab.VIEW;
}
